export enum LoginFormField {
  verificationCode = 'verificationCode',
}

export type LoginFormValues = {
  [LoginFormField.verificationCode]: string;
};
